import FormModal from "@/components/modals/FormModal";
import SelectInput from "@/components/selectInput/SelectInput";
import Dropzone from "@/components/dropzone/DropZone";
import { addOnsTypes } from "@/constants/CompanyData";
import React, { FC } from "react";
import { Button, Input } from "@thdinc/hpf-shared";
import { useDecimalInput } from "@/hooks/useDecimalInput";

interface AddOnModalProps {
    isOpen: boolean;
    onClose: () => void;
    addOnIsEdit: boolean;
    roles: string;
    isEditByBtC: boolean;
    addOnImage: { file?: File; img: string } | undefined;
    uploadAddOnImg: (file: any) => void;
    removeAddOnImage: () => void;
    addOnName: string;
    setAddOnName: (value: string) => void;
    addOnType: string;
    setAddOnType: (value: string) => void;
    addOnDesc: string;
    setAddOnDesc: (value: string) => void;
    addOnCost: string;
    setAddOnCost: (value: string) => void;
    addOnPrice: string;
    setAddOnPrice: (value: string) => void;
    addOnMinPrice: string;
    setAddOnMinPrice: (value: string) => void;
    includeInPackage: boolean;
    setIncludeInPackage: (value: boolean) => void;
    addOnPrepTime: boolean;
    setAddOnPrepTime: (value: boolean) => void;
    addOnError: string;
    canSubmit: boolean;
    onSubmit: () => void;
}

const AddOnModal: FC<AddOnModalProps> = ({
    isOpen,
    onClose,
    addOnIsEdit,
    roles,
    isEditByBtC,
    addOnImage,
    uploadAddOnImg,
    removeAddOnImage,
    addOnName,
    setAddOnName,
    addOnType,
    setAddOnType,
    addOnDesc,
    setAddOnDesc,
    addOnCost,
    setAddOnCost,
    addOnPrice,
    setAddOnPrice,
    addOnMinPrice,
    setAddOnMinPrice,
    includeInPackage,
    setIncludeInPackage,
    addOnPrepTime,
    setAddOnPrepTime,
    addOnError,
    canSubmit,
    onSubmit,
}) => {
    const addOnCostField = useDecimalInput(addOnCost, setAddOnCost, 999);
    const addOnPriceField = useDecimalInput(addOnPrice, setAddOnPrice, 999);
    const addOnMinPriceField = useDecimalInput(addOnMinPrice, setAddOnMinPrice, 999);

    return (
        <FormModal
            overflow="overflow-hidden "
            modalTitle={addOnIsEdit ? "Update Add-on" : "Create Add-on"}
            isOpen={isOpen}
            width="lg:w-3/6 md:w-5/6 w-full"
            height="overflow-y-auto"
            onClose={onClose}
        >
            <div className="mt-2 px-3">
                <div className="flex gap-4 justify-between sm:items-start flex-col sm:flex-row items-center">
                    <div className="flex-2 ">
                        <Dropzone
                            image={addOnImage?.img !== "undefined" && addOnImage?.img}
                            imgStyle={"w-24 h-24 rounded-xl"}
                            removeImage={() => removeAddOnImage()}
                            onDrop={uploadAddOnImg}
                        ></Dropzone>
                    </div>

                    <div className="flex flex-col gap-1 w-full  flex-grow ">
                        <div className="flex gap-2 flex-col  sm:flex-row">
                            <div className="w-full">
                                <p className="font-semibold mb-1">Name:</p>
                                <input
                                    disabled={!isEditByBtC && !roles && addOnIsEdit}
                                    className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                    maxLength={50}
                                    value={addOnName}
                                    onChange={(e) => setAddOnName(e.target.value)}
                                    type="text"
                                    placeholder="Name"
                                />
                            </div>
                            <div className="w-full">
                                <p className="font-semibold mb-1">Types:</p>
                                <SelectInput
                                    border="none"
                                    classes="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                    rounded="rounded-full"
                                    options={addOnsTypes}
                                    value={addOnType}
                                    onChange={(selectedValue: string) => {
                                        setAddOnType(selectedValue);
                                    }}
                                />
                            </div>
                            <div className="w-full">
                                <p className="font-semibold mb-1">Description:</p>
                                <input
                                    maxLength={200}
                                    className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                    value={addOnDesc}
                                    onChange={(e) => setAddOnDesc(e.target.value)}
                                    type="text"
                                    placeholder="Description"
                                />
                            </div>
                        </div>
                        <div className="flex gap-2 flex-col sm:flex-row">
                            <div className="w-full">
                                <p className="font-semibold mb-1">Cost:</p>
                                <input
                                    className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                    placeholder="Cost"
                                    {...addOnCostField}
                                />
                            </div>
                            <div className="w-full">
                                <p className="font-semibold mb-1">Profit:</p>
                                <input
                                    className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none focus:ring-1 focus:ring-primary-red text-gray-600"
                                    placeholder="Profit"
                                    {...addOnPriceField}
                                />
                            </div>
                            <div className="w-full">
                                <p className="font-semibold mb-1">Total:</p>
                                <input
                                    value={(
                                        Number(addOnPrice ? addOnPrice : 0) +
                                        Number(addOnCost ? addOnCost : 0)
                                    ).toFixed(2)}
                                    className="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                    type="number"
                                    placeholder="Pre Add-on"
                                    step={1}
                                    max={999}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        {/**add cost above it*/}
                        <div className="flex gap-2 flex-col sm:flex-row">
                            <div className="w-full">
                                <p className="font-semibold mb-1">Minimun Price:</p>
                                <input
                                    className="w-full px-4 py-3 bg-p-gray rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                                    placeholder="Minimum Price"
                                    {...addOnMinPriceField}
                                />
                            </div>
                            <div className="w-full gap-2 flex justify-start items-center pt-7">
                                <Input
                                    disabled={isEditByBtC === false && !roles && addOnIsEdit}
                                    className="cursor-pointer w-4 accent-primary-red"
                                    type="checkbox"
                                    checked={includeInPackage}
                                    onChange={(e) => setIncludeInPackage(!includeInPackage)}
                                />
                                <label htmlFor="">Include in Package</label>
                            </div>
                            {addOnType == "hourly" ? (
                                <div className="w-full gap-2 flex justify-start items-center pt-7 ml-0 sm:ml-2">
                                    <Input
                                        className="cursor-pointer w-4 accent-primary-red"
                                        type="checkbox"
                                        checked={addOnPrepTime}
                                        onChange={(e) => setAddOnPrepTime(!addOnPrepTime)}
                                    />
                                    <label htmlFor="">Prep/Clean up time</label>
                                </div>
                            ) : (
                                <div className="w-full gap-2 flex justify-start items-center pt-7 ml-0 sm:ml-2"></div>
                            )}
                        </div>
                    </div>
                </div>
                {addOnError && (
                    <p className="text-primary-red text-xs ">{addOnError}</p>
                )}
                <div className="flex justify-end mb-5 md:mb-0">
                    <Button
                        disabled={!canSubmit}
                        type="button"
                        classes={` ${!canSubmit ? "bg-gray-400" : "bg-primary-red"
                            } text-sm text-white rounded px-3 py-2 cursor-pointer`}
                        onClick={onSubmit}
                    >
                        {addOnIsEdit ? "Update" : "Add"}
                    </Button>
                </div>
            </div>
        </FormModal>
    );
};

export default AddOnModal;
